module.exports = __webpack_public_path__ + "img/2.4a231d57.jpg";